<ng-container>
  <app-authorization-handlling-cell-date [auths]="cell"></app-authorization-handlling-cell-date>
  <app-authorization-handlling-cell-role [auths]="cell"></app-authorization-handlling-cell-role>
  <app-authorization-handlling-cell-user [auths]="cell"></app-authorization-handlling-cell-user>
</ng-container>
